import apiClient from './client';
import { buildJsonApiQuery } from '@/utils/jsonapi';

/**
 * Tags API module
 * Handles CRUD operations for tags
 * Returns raw JSON:API responses - normalization happens in Redux thunks
 */
const tagsAPI = {
  /**
   * Get all tags for the current tenant
   * @param {Object} [queryOptions] - JSON:API query options
   * @returns {Promise<Object>} JSON:API response with tag data
   */
  getAll: async (queryOptions = {}) => {
    const params = buildJsonApiQuery(queryOptions);
    const response = await apiClient.get('/tags/', { params });
    return response.data;
  },

  /**
   * Create a new tag
   * @param {Object} data - Tag data
   * @param {string} data.name - Tag name
   * @param {string} data.color - Tag hex color (e.g., '#ff0000')
   * @returns {Promise<Object>} JSON:API response with created tag
   */
  create: async (data) => {
    const response = await apiClient.post('/tags/', data);
    return response.data;
  },

  /**
   * Update an existing tag
   * @param {string} tagId - Tag ID
   * @param {Object} data - Updated tag data
   * @returns {Promise<Object>} JSON:API response with updated tag
   */
  update: async (tagId, data) => {
    const response = await apiClient.patch(`/tags/${tagId}/`, data);
    return response.data;
  },

  /**
   * Delete a tag
   * @param {string} tagId - Tag ID
   * @returns {Promise<void>}
   */
  delete: async (tagId) => {
    await apiClient.delete(`/tags/${tagId}/`);
  },
};

export default tagsAPI;
